export default (state = {}, action) => {
  switch (action.type) {
    case 'USER_ICD10':
      return {
        ...state,
        userICD10: action.data
      };

    case 'SYSTEM_ICD10':
      return {
        ...state,
        systemICD10: action.data
      };

    default:
      return state;
  }
};
